export const wait = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
export const timeout = (ms, promise) => {
  let pendingTimeout;
  return new Promise((resolve, reject) => {
    pendingTimeout = setTimeout(() => reject(new Error("timeout")), ms);
    promise.then(resolve, reject);
  }).finally(() => clearTimeout(pendingTimeout));
};
